import axios from "axios";

export const servRecordtApiID = async (httpStr, rxFnc) => {
     await axios
    .get(httpStr)
    .then((res) => {
      //console.log("+++End api+++");
      //console.log(res.data.id);
      rxFnc(res.data.id);
      return res.data.id;
    })
    .catch((error) => {
      console.log(error.message);
      //console.log("---End api---");
      return 0;
    });
};

export const servRecordLocation = async (httpStrGetData, rxFnc) => {
     await axios
    .get(httpStrGetData)
    .then((res) => {
      //console.log("+++start api+++");
      //console.log(res.data);
      rxFnc(res.data);
      return res.data;
    })
    .catch((error) => {
      console.log(error.message);
      console.log("---End api---");
      return 0;
    });
};


export const servPostLocation = async (api) => {
  //console.log(api.postLocationResponse)
  //console.log(api.location)
    await axios
   .post(api.postLocationResponse, api.location)
   .then((res) => {
     //console.log("+++End api+++");
     //console.log(res.data);
     //rxFnc(res.data.id);
     return res.data.id;
   })
   .catch((error) => {
     console.log(error.message);
     console.log("---End api---");
     return 0;
   });
};


export const servPostSubmData = async (dataForm) => {
  //console.log(dataForm.api.postSubmDataResponse)
  const article = {...dataForm.submitData, order_id: dataForm.api.id}
  //console.log(article)
    await axios
   .post(dataForm.api.postSubmDataResponse, article)
   .then((res) => {
     //console.log("+++End api+++");
     //console.log(res.data);
     //rxFnc(res.data.id);
     return res.data.id;
   })
   .then()
   .catch((error) => {
     console.log(error.message);
     console.log("---End api---");
     return 0;
   });
};

export const getPartNumberCode = (
  isupply, isignal, ifrequency, iproductName, itempRange, istability, iaging
) => {
   //console.log(isupply, isignal, ifrequency, iproductName, itempRange, istability, iaging)
/*   if (
    !isupply || !isignal || !ifrequency || !iproductName || !itempRange || !istability || !iaging
  ) console.log("OK") */

  if ([isupply, isignal, ifrequency, iproductName, itempRange, istability, iaging]
    .some(val => val == null)) {
      //console.log("OK - есть undefined или null");
      return null
    }

    const voltage = isupply === '3.3V' ? '3' : '5';
    const signalType = isignal === 'Sine' ? 'S' : 'C';
    const freq = parseFloat(ifrequency) < 10 
      ? `0${parseFloat(ifrequency)}` 
      : parseFloat(ifrequency);
    
    // Use product name from currentProduct if available
    //const productName = productName;
    const partNumber = `${iproductName}-${itempRange}-${istability}-${iaging}-${voltage}-${signalType}-${freq}`;
    //console.log("partNumber: ", partNumber)
    return partNumber
   /* 
  {
    "tempRange": "5",
    "frequency": "8",
    "supplySignal": "sWave3p3V",
    "supply": "3.3V",
    "signal": "HCMOS",
    "aging": "50",
    "stability": "50"
}
  */
  //console.log(dataForm)
  // const voltage = dataForm.supply === '3.3V' ? '3' : '5';
  // const signalType = dataForm.signal === 'Sine' ? 'S' : 'C';
  // const freq = parseFloat(dataForm.frequency) < 10 
  //   ? `0${parseFloat(dataForm.frequency)}` 
  //   : parseFloat(dataForm.frequency);
  
  // Use product name from currentProduct if available
  //const productName = productName;
  
  //return `${productName}-${dataForm.tempRange}-${dataForm.stability}-${dataForm.aging}-${voltage}-${signalType}-${freq}`;
};
export const getPartNumberCode0 = (productName, dataForm) => {
  /* 
  {
    "tempRange": "5",
    "frequency": "8",
    "supplySignal": "sWave3p3V",
    "supply": "3.3V",
    "signal": "HCMOS",
    "aging": "50",
    "stability": "50"
}
  */
  //console.log(dataForm)
  const voltage = dataForm.supply === '3.3V' ? '3' : '5';
  const signalType = dataForm.signal === 'Sine' ? 'S' : 'C';
  const freq = parseFloat(dataForm.frequency) < 10 
    ? `0${parseFloat(dataForm.frequency)}` 
    : parseFloat(dataForm.frequency);
  
  // Use product name from currentProduct if available
  //const productName = productName;
  
  return `${productName}-${dataForm.tempRange}-${dataForm.stability}-${dataForm.aging}-${voltage}-${signalType}-${freq}`;
};